export default {"src":"/_next/static/media/Ceph.19288f5e.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};